export default "__VITE_ASSET__BGud_dEM__"